import React, { cloneElement } from 'react';

import { ChatInput, ChatInputProps } from '~/components/chat';
import { AppRoute } from '~/routes';
import { InsightsDrawerRender } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawerRender';

import * as S from './View.styles';

export interface AccountViewProps {
  config: AppRoute;
}

export const View = ({ config }: AccountViewProps) => {
  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) => <ChatInput {...props} />,
  });

  return (
    <>
      <S.ViewRoot id={'root-view'}>
        {content}
        <InsightsDrawerRender />
      </S.ViewRoot>
    </>
  );
};
